import { CommandType, ScriptCommands } from '../../types/dashboard';
import { queryLogAwsCliInstallScript } from '../commands';

/** Replaced with the project's PostgreSQL major version by CommandsGroup. */
export const PG_VERSION_PLACEHOLDER = '<pg_version>';

const exportSchemaCommand =
  `exsch-pg --pg_version ${PG_VERSION_PLACEHOLDER} --db_name <db_name> -h <host> -p <port> -u <db_user> --db_schema <schema>`;

const exportDataCommand =
  'poetry run exdbd --db_name <database_name> --db_schema <schema_name> --db_host <database_host> --db_port <database_port> --db_user <database_username>';

// Query-log capture isn't built for PostgreSQL yet.
const notYetAvailable: CommandType[] = [
  {
    commands: [],
    title: 'Not yet available for PostgreSQL',
    description:
      'This step is coming in a later release. The schema export and the data export are available for PostgreSQL projects today.',
  },
];

export const staticCommandsDataPOSTGRES: ScriptCommands = {
  saveSchemaToFile: [
    {
      commands: [exportSchemaCommand],
      title: 'Save PostgreSQL Schema to File',
      description:
        'Runs pg_dump of your server\'s major version in Docker after checking the schema can be recreated on RDS. ' +
        'The result is written to output/<db_name>/tables/schema.sql. You are prompted for the password, or set PGPASSWORD first.',
    },
    {
      commands: [`${exportSchemaCommand} --sslrootcert global-bundle.pem`],
      title: 'Optional: verify the server certificate',
      description:
        'The connection is always encrypted. To also verify the server, download the RDS global CA bundle ' +
        '(https://truststore.pki.rds.amazonaws.com/global/global-bundle.pem) and pass it with --sslrootcert.',
    },
  ],
  saveSchemaInstallScript: [
    {
      commands: ['docker --version', 'docker info'],
      title: 'Verify Docker is installed and running',
      description:
        'The PostgreSQL schema exporter runs pg_dump inside Docker, so no PostgreSQL client tools are needed. ' +
        'The first run builds the image, which needs internet access.',
    },
  ],
  saveSchemaDownloadScript: [
    {
      commands: ['cd postgres_schema_exporter'],
      title: 'Move to postgres_schema_exporter directory',
      description: '',
    },
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry install',
      ],
      title: 'Install the script',
      description: 'The command below runs in its environment with poetry run.',
    },
    {
      commands: [`poetry run ${exportSchemaCommand}`],
      title: 'Run script',
      description: 'Execute the schema export script for PostgreSQL',
    },
  ],
  createQueryLogSection1: notYetAvailable,
  createQueryLogSection2: notYetAvailable,
  exportDatabase: notYetAvailable,
  downloadScript: notYetAvailable,
  settingUpTheSystemCommandSection1: [
    {
      commands: ['python3.12 --version'],
      title: '',
      description: '',
    },
  ],
  settingUpTheSystemCommandSection2: [
    {
      commands: [
        'curl -sSL https://install.python-poetry.org | python3 -',
        'poetry --version',
      ],
      title: '',
      description: '',
    },
  ],
  settingUpTheSystemCommandSection3: [
    {
      commands: ['docker --version', 'docker info'],
      title: '',
      description: '',
    },
  ],
  queryLogExtractionSetupCommand1: notYetAvailable,
  queryLogExtractionSetupCommand2: notYetAvailable,
  exportQueryLogsScript: notYetAvailable,
  enableQueryLogsScript: notYetAvailable,
  disableQueryLogsScript: notYetAvailable,
  exportDataAndDeidentificationScript: [
    {
      commands: [
        'sudo apt-get install unzip',
        'unzip script.zip -d <destination_folder>',
      ],
      title: 'Extract the package',
      description: '',
    },
    {
      commands: ['cd export_and_deidentify'],
      title: 'Move to export and deidentification directory',
      description: '',
    },
    {
      commands: ['poetry env use python3.12', 'poetry install'],
      title: 'Install the script',
      description: 'The script needs Python 3.12. Commands below run in its environment with poetry run.',
    },
    {
      commands: [exportDataCommand],
      title: 'Run script',
      description:
        'Exports the core tables as one consistent snapshot, de-identifies the selected columns and writes data.zip. ' +
        'You are prompted for the password, or press Enter to use PGPASSWORD. The user needs SELECT on the core tables.',
    },
    {
      commands: [`${exportDataCommand} --sslrootcert global-bundle.pem`],
      title: 'Optional: verify the server certificate',
      description:
        'The connection is always encrypted. To also verify the server, download the RDS global CA bundle ' +
        '(https://truststore.pki.rds.amazonaws.com/global/global-bundle.pem) and pass it with --sslrootcert.',
    },
  ],
  shareDeidentifiedFileScript: notYetAvailable,
  queryLogAwsCliInstallScript,
};
